import React from "react";
import { useTranslation } from "react-i18next";
const HowItWorks = () => {
  const { t } = useTranslation();

  const steps = [
    {
      id: 1,
      number: "1",
      title: t("Create Your Event"),
    },
    {
      id: 2,
      number: "2",
      title: t("Add Categories\n& Registration Options"),
    },
    {
      id: 3,
      number: "3",
      title: t("Launch & Share"),
    },
    {
      id: 4,
      number: "4",
      title: t("Track Everything\nin Real Time"),
    },
  ];

  return (
    <section className="relative py-16 xl:py-20 2xl:py-24 bg-secondary-gradient space-y-20">
      <div className="max-w-4xl xl:max-w-6xl 2xl:max-w-6xl 3xl:max-w-7xl w-full mx-auto">
        <h2 className="text-2xl xl:text-3xl 2xl:text-4xl font-bold text-white capitalize text-center mb-1">
          {t("how it works")}
        </h2>
        <div className="text-center text-2xl xl:text-3xl 2xl:text-4xl text-white mb-10 xl:mb-14 2xl:mb-16">
          {t("A Simple 4 Step Journey")}
        </div>
        <div className="flex justify-center items-start gap-4 flex-wrap px-4">
          {steps.map((step, index) => (
            <React.Fragment key={index}>
              <div className="flex flex-col items-center text-center max-w-full md:max-w-44 xl:max-w-52 2xl:max-w-60">
                <div className="w-16 md:w-20 xl:w-28 2xl:w-36 aspect-square border-4 2xl:border-8 border-white rounded-full flex items-center justify-center text-4xl xl:text-5xl 2xl:text-6xl 3xl:text-7xl font-bold mb-5 xl:mb-8 2xl:mb-10 text-white">
                  {step.number}
                </div>
                <div className="text-lg xl:text-xl 2xl:text-2xl text-white font-bold ">
                  {step.title}
                </div>
              </div>
              {index < steps.length - 1 && (
                <div className="text-3xl xl:text-4xl 2xl:text-5xl text-white mt-0 md:mt-8 2xl:mt-14 md:w-auto w-full text-center">
                  <i className="fa-regular fa-chevron-right hidden md:block"></i>
                  <i className="fa-regular fa-chevron-down block md:hidden"></i>
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
